export default "__VITE_ASSET__DV7Hzp8i__"